import React, {useRef, useEffect} from 'react';

export function useTableScroll(
  loadMore,
  selector = '.awl-custom-table',
  {margin} = {margin: 5},
) {
  const shouldLoad = useRef(true);
  useEffect(() => {
    const fetchOnScrollToBottom = (e) => {
      if (e.target.matches && e.target.matches(selector)) {
        if (
          e.target.scrollTop + margin >=
          e.target.scrollHeight - e.target.offsetHeight
        ) {
          if (shouldLoad.current) {
            // console.log(
            //   e.target.scrollTop,
            //   e.target.scrollHeight - e.target.offsetHeight,
            // );
            shouldLoad.current = false;
            loadMore();
          }
        } else {
          shouldLoad.current = true;
        }
      }
    };
    window.addEventListener('scroll', fetchOnScrollToBottom, true);
    return () => {
      window.removeEventListener('scroll', fetchOnScrollToBottom, true);
    };
  }, [loadMore]);
}

//todo: debounce->X throttle it https://dev.to/pulkitnagpal/using-throttling-and-debouncing-with-react-hooks-57f1
